
/* injects from baggage-loader */

'use strict';

export default class DonationConfirmationController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/donation-confirmation/donation-confirmation.controller.js